<template>
    <div :class="$attrs.class">
      <label v-if="labelGroup" class="form-label" :for="id">{{ labelGroup }}:</label>
      <label class="wrapper flex items-center">        
        <input class="checkbox"
        type="checkbox"
        ref="input" 
        :id="id"
         :checked="isChecked" 
         :value="value"
         v-model="selected"
         @change="updateInput" />
        <span class="checkmark pr-2"></span>
        {{label}}
      </label>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  data() {
    return {
      selected: this.modelValue,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
    modelValue(modelValue) {
      this.selected = modelValue;
    },
  },
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    "value": { type: String },
    modelValue: [String, Number, Boolean],
    "label": { type: String},
    "labelGroup": { type: String},
    "trueValue": { default: true },
    "falseValue": { default: false }
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      return this.modelValue === this.trueValue
    }
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      if (this.modelValue instanceof Array) {        
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
}
</script>